import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

// Redux Form
import { Field, reduxForm } from 'redux-form';

import {
  Button,
  FormGroup,
  FormControl,
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

// Component
import CountryList from '../../CountryList';

// Helpers
import validate from './validate';
import history from '../../../core/history';

// Locale
import messages from '../../../locale/jsonMessages';

import cs from '../../../components/commonStyle.css';
import s from '../Payout.css';

class PayoutBillingDetails extends Component {
  static propTypes = {
    handleSubmit: PropTypes.any.isRequired,
    formatMessage: PropTypes.any,
    previousPage: PropTypes.any.isRequired,
  };

  renderField = ({ input, label, type, meta: { touched, error, dirty }, maxLength, className, isRequiredInput }) => {
    const { formatMessage } = this.props.intl;
    return (
      <FormGroup className={cx(cs.noMargin, className)}>
        <label className='commonLabelText'><span>{label}{isRequiredInput && <sup className='isRequiredStar'>*</sup>}</span></label>
        <FormControl {...input} componentClass="input" className='commonInputField' placeholder={label} maxLength={maxLength} />
        {touched && error && <span className='errorMessageText'>{formatMessage(error)}</span>}
      </FormGroup>
    );
  }

  renderCountryList = ({ input, label, meta: { touched, error }, children, className, isRequiredInput }) => {
    const { formatMessage } = this.props.intl;
    return (
      <FormGroup className={cs.noMargin}>
        <label className='commonLabelText'><span>{label}
          {isRequiredInput && <sup className='isRequiredStar'>*</sup>}</span></label>
        <CountryList input={input} className='commonSelectField' />
        {touched && error && <span className='errorMessageText'>{formatMessage(error)}</span>}
      </FormGroup>
    );
  }

  handleClick() {
    history.push('/user/payout');
  }

  render() {
    const { handleSubmit, previousPage } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div className={cx(cs.commonBorderSection, 'whiteBgColor')}>
        <h3 className={cx(cs.commonTotalText, cs.paddingBottom4)}>{formatMessage(messages.addPayout)}</h3>
        <form onSubmit={handleSubmit}>
          <div className="oneColumnGrid">
            <Field name="country" component={this.renderCountryList} label={formatMessage(messages.country)} isRequiredInput />
            <Field name="address1" component={this.renderField} label={formatMessage(messages.address1)} maxLength={255} isRequiredInput />
            <Field name="address2" component={this.renderField} label={formatMessage(messages.address2)} maxLength={255} />
            <div className='twoColumnGrid'>
              <Field name="city"
                component={this.renderField}
                label={formatMessage(messages.city)}
                maxLength={255}
                isRequiredInput />
              <Field name="state"
                component={this.renderField}
                label={formatMessage(messages.state)}
                maxLength={255}
                isRequiredInput />
            </div>
            <Field name="zipcode"
              component={this.renderField}
              label={formatMessage(messages.zipCode)}
              maxLength={30}
              isRequiredInput />
          </div>
          <div className={cx('doubleBtnFlexEnd', cs.spaceTop4)}>
            <Button className={cx(cs.btnPrimaryBorder)} onClick={this.handleClick}>
              <FormattedMessage {...messages.back} />
            </Button>
            <Button className={cx(cs.btnPrimary, 'loaderButtonFlex')} type="submit">
              <FormattedMessage {...messages.next} />
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

PayoutBillingDetails = reduxForm({
  form: 'PayoutForm', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(PayoutBillingDetails);

export default injectIntl(withStyles(cs, s)(PayoutBillingDetails));